import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import * as FundsSchemas from './funds.schemas';
export const createFundsAPI = createModule(({ http }) => ({
    deleteHoliday: async (id) => {
        const holidayId = parseInput(FundsSchemas.fundHolidayIdSchema, id);
        return http.delete(`/v2/funds/holidays/${encodeURIComponent(holidayId)}`);
    },
    createHolidays: async (body) => {
        const payload = parseInput(FundsSchemas.createFundHolidaysSchema, body);
        return http.post('/v2/funds/holidays', { body: payload });
    },
    getHolidays: async (params) => {
        const filters = parseInput(FundsSchemas.getFundHolidaysSchema, params);
        return http.get('/v2/funds/holidays', { params: filters });
    },
    /**
     * Get all funds.
     */
    getAll: async () => {
        const res = await http.get(`/v2/funds/`);
        return res;
    },
    update: async (body) => {
        const res = await http.patch('/v2/funds/', { body: body });
        return res;
    },
    create: async (body) => {
        const params = parseInput(FundsSchemas.createFundSchema, body);
        const res = await http.post('/v2/funds/', { body: params });
        return res;
    },
    getOCF: async (params) => {
        const res = await http.get('/v2/funds/ocf', {
            params,
        });
        return res;
    },
    getOCFChart: async (params) => {
        const res = await http.get('/v2/funds/ocf/chart', {
            params,
        });
        return res;
    },
    nav: {
        /**
         * Get NAV statistics for all funds for a given date.
         */
        getNav: async (params) => {
            const res = await http.get(`/v2/funds/nav`, { params });
            return res;
        },
        /**
         * Get soft NAV statistics for all funds for a given date.
         */
        getSoftNav: async (params) => {
            const res = await http.get(`/v2/funds/soft_nav`, {
                params,
            });
            return res;
        },
        /**
         * Get soft NAV breakdown for a fund on a given date.
         */
        getSoftBreakdown: async (params) => {
            const res = await http.get(`/v2/funds/soft_nav/breakdown`, {
                params,
            });
            return res;
        },
        /**
         * Get profit and loss details for a fund on a given date.
         */
        getSoftPnL: async (params) => {
            const res = await http.get(`/v2/funds/soft_nav/pnl_details`, {
                params,
            });
            return res;
        },
        /**
         * Update a NAV entry for a given
         */
        updateNav: async (params) => {
            const body = parseInput(FundsSchemas.updateNavEntrySchema, params);
            const res = await http.patch(`/v2/funds/nav`, { body });
            return res;
        },
        /**
         * Delete a NAV entry on a given date for a given fund.
         */
        deleteEntry: async (params) => {
            const body = parseInput(FundsSchemas.deleteNavEntrySchema, params);
            const res = await http.delete(`/v2/funds/nav/${body.fund_name}/${body.value_date}`);
            return res;
        },
        /**
         * Get Subscription / Redemption data
         */
        getSubscriptionRedemptionData: async () => {
            const res = await http.get(`/v2/funds/nav/subscription-redemption`);
            return res;
        },
    },
    positions: {
        getPositions: async (params) => {
            const res = await http.get(`/v2/funds/positions`, {
                params,
            });
            return res;
        },
        getPnL: async (params) => {
            const res = await http.get(`/v2/funds/pnl`, {
                params,
            });
            return res;
        },
    },
}));
